(function() { window.GUID_4af81b94_6dfc_47f9_bfc7_2dcd495cb6e5 = { getGuid: function() { return "4af81b94-6dfc-47f9-bfc7-2dcd495cb6e5"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Key;
    (function (Key) {
        let KeyHelperEnum;
        (function (KeyHelperEnum) {
            KeyHelperEnum[KeyHelperEnum["Enter"] = 0] = "Enter";
            KeyHelperEnum[KeyHelperEnum["UpArrow"] = 1] = "UpArrow";
            KeyHelperEnum[KeyHelperEnum["DownArrow"] = 2] = "DownArrow";
            KeyHelperEnum[KeyHelperEnum["LeftArrow"] = 3] = "LeftArrow";
            KeyHelperEnum[KeyHelperEnum["RightArrow"] = 4] = "RightArrow";
            KeyHelperEnum[KeyHelperEnum["Escape"] = 5] = "Escape";
            KeyHelperEnum[KeyHelperEnum["Spacebar"] = 6] = "Spacebar";
            KeyHelperEnum[KeyHelperEnum["Ctrl"] = 7] = "Ctrl";
            KeyHelperEnum[KeyHelperEnum["Alt"] = 8] = "Alt";
            KeyHelperEnum[KeyHelperEnum["Tab"] = 9] = "Tab";
            KeyHelperEnum[KeyHelperEnum["Shift"] = 10] = "Shift";
            KeyHelperEnum[KeyHelperEnum["CapsLock"] = 11] = "CapsLock";
            KeyHelperEnum[KeyHelperEnum["WindowsKey"] = 12] = "WindowsKey";
            KeyHelperEnum[KeyHelperEnum["WindowsOptionKey"] = 13] = "WindowsOptionKey";
            KeyHelperEnum[KeyHelperEnum["Backspace"] = 14] = "Backspace";
            KeyHelperEnum[KeyHelperEnum["Home"] = 15] = "Home";
            KeyHelperEnum[KeyHelperEnum["End"] = 16] = "End";
            KeyHelperEnum[KeyHelperEnum["Insert"] = 17] = "Insert";
            KeyHelperEnum[KeyHelperEnum["Delete"] = 18] = "Delete";
            KeyHelperEnum[KeyHelperEnum["PageUp"] = 19] = "PageUp";
            KeyHelperEnum[KeyHelperEnum["PageDown"] = 20] = "PageDown";
            KeyHelperEnum[KeyHelperEnum["Numlock"] = 21] = "Numlock";
            KeyHelperEnum[KeyHelperEnum["ScrollLock"] = 22] = "ScrollLock";
            KeyHelperEnum[KeyHelperEnum["PauseBreak"] = 23] = "PauseBreak";
            KeyHelperEnum[KeyHelperEnum["Numeric"] = 24] = "Numeric";
            KeyHelperEnum[KeyHelperEnum["Alpha"] = 25] = "Alpha";
            KeyHelperEnum[KeyHelperEnum["Undefined"] = 26] = "Undefined";
            KeyHelperEnum[KeyHelperEnum["F1"] = 27] = "F1";
            KeyHelperEnum[KeyHelperEnum["F2"] = 28] = "F2";
            KeyHelperEnum[KeyHelperEnum["F3"] = 29] = "F3";
            KeyHelperEnum[KeyHelperEnum["F4"] = 30] = "F4";
            KeyHelperEnum[KeyHelperEnum["F5"] = 31] = "F5";
            KeyHelperEnum[KeyHelperEnum["F6"] = 32] = "F6";
            KeyHelperEnum[KeyHelperEnum["F7"] = 33] = "F7";
            KeyHelperEnum[KeyHelperEnum["F8"] = 34] = "F8";
            KeyHelperEnum[KeyHelperEnum["F9"] = 35] = "F9";
            KeyHelperEnum[KeyHelperEnum["F10"] = 36] = "F10";
            KeyHelperEnum[KeyHelperEnum["F11"] = 37] = "F11";
            KeyHelperEnum[KeyHelperEnum["F12"] = 38] = "F12";
            KeyHelperEnum[KeyHelperEnum["Minus"] = 39] = "Minus";
            KeyHelperEnum[KeyHelperEnum["Plus"] = 40] = "Plus";
        })(KeyHelperEnum = Key.KeyHelperEnum || (Key.KeyHelperEnum = {}));
        function TestKeyEvent(keyEvent) {
            var key = keyEvent.which;
            if (key >= 65 && key <= 90) {
                return KeyHelperEnum.Alpha;
            }
            if (key >= 48 && key <= 57) {
                return KeyHelperEnum.Numeric;
            }
            switch (key) {
                case 8:
                    return KeyHelperEnum.Backspace;
                case 9:
                    return KeyHelperEnum.Tab;
                case 13:
                    return KeyHelperEnum.Enter;
                case 16:
                    return KeyHelperEnum.Shift;
                case 17:
                    return KeyHelperEnum.Ctrl;
                case 18:
                    return KeyHelperEnum.Alt;
                case 19:
                    return KeyHelperEnum.PauseBreak;
                case 20:
                    return KeyHelperEnum.CapsLock;
                case 27:
                    return KeyHelperEnum.Escape;
                case 32:
                    return KeyHelperEnum.Spacebar;
                case 33:
                    return KeyHelperEnum.PageUp;
                case 34:
                    return KeyHelperEnum.PageDown;
                case 35:
                    return KeyHelperEnum.End;
                case 36:
                    return KeyHelperEnum.Home;
                case 37:
                    return KeyHelperEnum.LeftArrow;
                case 38:
                    return KeyHelperEnum.UpArrow;
                case 39:
                    return KeyHelperEnum.RightArrow;
                case 40:
                    return KeyHelperEnum.DownArrow;
                case 45:
                    return KeyHelperEnum.Insert;
                case 46:
                    return KeyHelperEnum.Delete;
                case 91:
                    return KeyHelperEnum.WindowsKey;
                case 107:
                    return KeyHelperEnum.Plus;
                case 187:
                    return KeyHelperEnum.Plus;
                case 109:
                    return KeyHelperEnum.Minus;
                case 189:
                    return KeyHelperEnum.Minus;
                case 112:
                    return KeyHelperEnum.F1;
                case 113:
                    return KeyHelperEnum.F2;
                case 114:
                    return KeyHelperEnum.F3;
                case 115:
                    return KeyHelperEnum.F4;
                case 116:
                    return KeyHelperEnum.F5;
                case 117:
                    return KeyHelperEnum.F6;
                case 118:
                    return KeyHelperEnum.F7;
                case 119:
                    return KeyHelperEnum.F8;
                case 120:
                    return KeyHelperEnum.F9;
                case 121:
                    return KeyHelperEnum.F10;
                case 122:
                    return KeyHelperEnum.F11;
                case 123:
                    return KeyHelperEnum.F12;
                case 144:
                    return KeyHelperEnum.Numlock;
                default:
            }
            return KeyHelperEnum.Undefined;
        }
        Key.TestKeyEvent = TestKeyEvent;
    })(Key = CompuSport.Key || (CompuSport.Key = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=KeyHelper.js.map
